import { Button, styled } from '@mui/material';

export const NarrowButton = styled(Button)(() => ({
  padding: 8,
  minWidth: 'auto',
}));
